export class DynamicBaseForm<T> {
    value: T|undefined;
    key: string;
    label_es: string;
    label_en: string;
    required: boolean;
    //order: number;
    controlType: string;
    type: string;
    options: {key: string, value: string}[];
  
    constructor(options: {
        value?: T;
        key?: string;
        label_es?: string;
        label_en?: string;
        required?: boolean;
        //order?: number;
        controlType?: string;
        type?: string;
        options?: {key: string, value: string}[];
      } = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label_es = options.label_es || '';
        this.label_en = options.label_en || '';
        this.required = !!options.required;
        //this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
        this.type = options.type || '';
        this.options = options.options || [];
    }
  }
  